import { OrdinalSuffixOf } from "./RandomHelpers";

const DayOfWeek = (day) => {
    switch (day) {
        case "1":
            return "Monday";
        case "2":
            return "Tuesday";
        case "3":
            return "Wednesday";
        case "4":
            return "Thursday";
        case "5":
            return "Friday";
        case "6":
            return "Saturday";
        case "7":
            return "Sunday";
    }
}

export const scheduleDescription = (picked_schedule) => {
    var getText = () => {
        var time_based = "";
        var day_based = "";
        var week_based = "";
        var month_based = "";

        if (picked_schedule.time_frequency) {
            var time_periods = picked_schedule.time_frequency.split(":")
            var hours = parseInt(time_periods[0]);
            var minutes = parseInt(time_periods[1]);

            time_based = `every ${hours > 0 ? hours + " hours" : ""}${hours > 0 && minutes > 0 ? " and " : ""}${minutes > 0 ? minutes + " minutes" : ""}`
        }
        if (picked_schedule.daily) {
            day_based = `every${picked_schedule.daily > 1 ? " " + OrdinalSuffixOf(picked_schedule.daily) + " day" : "day"}`;
        }
        if (picked_schedule.weekly) {
            var daysOfWeek = picked_schedule.weekly.split(",");

            week_based = `on ${daysOfWeek.map((x, i, arr) => {
                if (i < arr.length - 1) {
                    return DayOfWeek(x) + (i === arr.length - 2 ? " " : ", ")
                } else if (arr.length !== 1) {
                    return "and " + DayOfWeek(x);
                } else {
                    return DayOfWeek(x);
                }
            }).join("")} of each week`;
        }
        if (picked_schedule.monthly) {
            var daysOfMonth = picked_schedule.monthly.split(",");

            month_based = `${
                daysOfMonth.filter(x => x[0] !== "-" && x !== "0").length > 0 ?
                    "on the " +
                    daysOfMonth.filter(x => x[0] !== "-" && x !== "0").map((x, i, arr) => {
                        if (i < arr.length - 1) {
                            return OrdinalSuffixOf(parseInt(x)) + (i === arr.length - 2 ? " " : ", ")
                        } else if (arr.length !== 1) {
                            return "and " + OrdinalSuffixOf(parseInt(x));
                        } else {
                            return OrdinalSuffixOf(parseInt(x));
                        }
                    }).join("") + " of each month"
                    : ""
                }${
                daysOfMonth.some(x => x[0] === "-") && daysOfMonth.some(x => x[0] !== "-" && x !== "0") ? " and " : ""
                }${
                daysOfMonth.filter(x => x[0] === "-").length ?
                    daysOfMonth.filter(x => x[0] === "-").map((x, i, arr) => {
                        if (i < arr.length - 1) {
                            return x.substring(1) + (i === arr.length - 2 ? " " : ", ")
                        } else if (arr.length !== 1) {
                            return "and " + x.substring(1);
                        } else {
                            return x.substring(1);
                        }
                    }).join("") + " days before the first of each month"
                    : ""
                }`;
        }

        return `Report will run ${
            (time_based || "") +
            ((time_based && day_based) ? ((week_based && month_based ? ", " : week_based || month_based ? " and " : "") + day_based) : (day_based || "")) +
            (week_based ? (month_based ? (" and " + week_based) : week_based) : "") +
            month_based || ""
            } at ${picked_schedule.runtime.split(":")[0] + ":" + picked_schedule.runtime.split(":")[1]}`;
    }

    if (picked_schedule) {
        return getText();
    } else {
        return "Report will not run";
    }
}

export const cleanReportName = (name) => {
    return name.replace(/\{[a-zA-Z0-9\\\/|<>@'"=+,!#$%^&*()?:;._-\s]{0,}\}/g,"").trim();
}